// extracted by mini-css-extract-plugin
export default {"UploadFontContainer":"UploadFont_UploadFontContainer__HZCyv","UploadFontIdentifierText":"UploadFont_UploadFontIdentifierText__CCme1"};